import { CarDataApiProvider, CarDataApiProviderLabels } from '@navio/nsdk';
import { getLabelMapFromEntries } from 'noddi-util';

const PROVIDER_LABEL = getLabelMapFromEntries(CarDataApiProvider, CarDataApiProviderLabels);

// Operators think in countries, not provider names, so each register carries the market it covers.
const PROVIDER_COUNTRY: Record<CarDataApiProvider, string> = {
  [CarDataApiProvider.CAR_INFO]: 'DK',
  [CarDataApiProvider.RDW]: 'NL',
  [CarDataApiProvider.STATENS_VEGVESEN]: 'NO'
};

export const registrySourceLabel = (provider: CarDataApiProvider) =>
  `${PROVIDER_LABEL[provider]} (${PROVIDER_COUNTRY[provider]})`;
